export const NAME = 'pdf';